export default "__VITE_ASSET__D3qNSNFN__"